import React from 'react';
import { I18n } from 'react-redux-i18n';

import ModernDatepicker from 'react-modern-datepicker';

const DateRangeInput = (props) => {
  const { initialDate, finalDate, handleDate } = props;

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="form-group form-promotion-picker">
          <p className="margin-bottom-2">{I18n.t('initialDate')}</p>
          <div className="inputs">
            <ModernDatepicker
              className="form-control"
              showBorder
              placeholder=""
              format="DD/MM/YYYY"
              date={initialDate}
              onChange={date => handleDate(date, 'initialDate')}
            />
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="form-group form-promotion-picker">
          <p className="margin-bottom-2">{I18n.t('finalDate')}</p>
          <div className="inputs">
            <ModernDatepicker
              className="form-control"
              showBorder
              placeholder=""
              format="DD/MM/YYYY"
              date={finalDate}
              onChange={date => handleDate(date, 'finalDate')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateRangeInput;
